var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 59,
    viewBox: "0 0 81 59",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#231F20",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.348 26.64a1.404 1.404 0 1 0 0-2.796H1.452a1.404 1.404 0 0 0 0 2.796h10.896zM9.192 37.248c0 .775.629 1.404 1.404 1.404h10.896a1.404 1.404 0 0 0 0-2.796H10.596a1.392 1.392 0 0 0-1.404 1.392zM18.348 29.844H6.252a1.404 1.404 0 1 0 0 2.808h12.084a1.404 1.404 0 1 0 0-2.796l.012-.012zM2.628 32.664a1.404 1.404 0 1 0 0-2.808h-.552a1.404 1.404 0 1 0 0 2.808h.552zM27.6 43.248c0-.769-.623-1.392-1.392-1.392H2.688a1.404 1.404 0 0 0 0 2.796h23.52a1.392 1.392 0 0 0 1.392-1.404z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.896 41.688c-4.296-1.728-6.408-2.724-8.172-1.08.9-1.788.54-1.896-.216-3.216-1.5-2.652-5.484-6.996-6.852-15.276a44.16 44.16 0 0 0 2.4-9.672s.84-2.4-2.832-1.2a41.28 41.28 0 0 1-7.2 3.516c-4.572-.54-11.28-3.84-13.752-8.952 0 0 2.064-4.308.264-5.304-1.2-.684-4.944 3.168-4.944 3.168L17.46 17.82l-.936 1.74a2.22 2.22 0 0 0 .18 2.4c3.216 4.284 15.888 21.168 23.112 30.096-20.652.168-31.812 3.336-23.892 4.44 6.48.9 21.276.636 32.4.6 1.295.376 2.614.665 3.948.864l18.624.18c2.4-.132 4.608-.312 6.348-.504a3.084 3.084 0 0 0 2.544-1.968c2.004-5.364-1.152-10.884-8.892-13.98zm-37.2-10.284-.624-14.4 4.224 8.832 4.548-1.824 1.2 13.92-4.8-8.664-4.548 2.136z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fff13ff7961ae85c91cd3951744af799.svg";
export { ForwardRef as ReactComponent };